import React from "react";

const JumboPayTableBody = ({ data, tableSecture }) => {
  return (
    <div className="body-table">
      {data &&
        data.map((item, index) => (
          <div className={`row-item-table`} key={index}>
            {tableSecture.map((row, indexRow) => (
              <div className={row.fieldClass} key={indexRow}>
                {row.render(item)}
              </div>
            ))}
          </div>
        ))}
    </div>
  );
};

export default JumboPayTableBody;
